import ajax from '../../api/ajax'

const state = {
	/**
	 *  @author 80004302 
	 */
	selectorValid: true,		// 城市选择器邮编验证信息
	selectedAreaData: {			// 当前选择的城市信息
		province: null,
		city: null,
		country: null,
	},				
    selectedAreaDataDest: {			// 当前选择的城市信息
		province: null,
		city: null,
		country: null,
	},	
	normalRegions: [],          // 正常收送地区
	abnormalRegions: [],        // 特别收送地区
	unavailableRegions: [],     // 不服务地区
	level: 1,                   // 地域level值
	areaCode: '',               // 地域code值
	areaName: '请选择原寄地',    // 选择地址名
	currentTabId: 'chinaArea',  //默认中国大陆
	selectCityCode: '',         //选择的城市代码
	selectProvinceCode: '',     //选择的省代码(大陆)
	showResult: false,          // 是否展示查询结果
	errorMsg: '',               // 错误信息
	flag: 0,                    // todo

	// 表单数据，包裹一层防止双向绑定失效
	formData: {
		zipCode: ''               // 地域邮政编码
	}
}

const getters = {
	// 查询按钮是否可点击
	disabledBtn (state) {
		return state.level === 1 ? !state.formData.zipCode : !state.areaName
	},

	// 是否是国内地址
	isInternal (state) {
		return state.level !== 1
	},

	// 不可到达地区
	unavailableRegionNames (state) {
		let str = ''
		state.unavailableRegions.map((item) => {
			str += item.name + '、'
		})
		return str ? str.substring(0, str.length - 1) : ''
	},

	zipCode (state) {
		return state.formData.zipCode
	},
	selectorValid (state) {
		return state.selectorValid
	},
	getAreaData (state) {
        return state.selectedAreaData
    },
    getAreaDataDest (state) {
        return state.selectedAreaDataDest
	}
}

const mutations = {
	setSelectorValid(state, val) {
		state.selectorValid = val
	},
    setAreaData(state, data) {
        state.selectedAreaData = data
    },
    setAreaDataDest(state, data) {
        state.selectedAreaDataDest = data
    },
	// 处理国内地区数据
	handlerInternalData (state, data) {
		if (!data) return
		Object.assign(state, data)
		state.showResult = true
	},

	// 处理国外地区数据
	handlerGlobalData (state, data) {
		state.showResult = true
	},

	// 接口错误处理
	error (state, res) {
		if ([404, 403, 0].indexOf(res.status) > -1) {
			state.errorMsg = '对不起，查询不到数据'
		} else {
			state.errorMsg = '服务器暂不可用，请稍后再试'
		}
		state.flag++
	},

	// 是否显示结果栏
	showResult (state, b) {
		state.showResult = b
	},

	selectRegion (state, item) {
		state.level = item.level
		state.areaCode = item.code
		state.areaName = item.name
		state.currentTabId = item.currentTabId
		state.selectCityCode = item.selectCityCode
		state.selectProvinceCode = item.selectProvinceCode
		state.showResult = false
		state.formData.zipCode = ''
	}
}

const actions = {
	// 获取国内地区收寄范围
	getInternalRange ({commit, state}) {
		ajax.getInternalRange({
			params: {
				areaCode: state.areaCode === 'NODATA' ? state.selectCityCode : state.areaCode
			}
		}).then(res => commit('handlerInternalData', res.data))
			.catch(res => commit('error', res))
	},

	getGlobalRange ({commit, state}) {
		ajax.getGlobalRange({
			params: {
				areaCode: state.areaCode,
				zipCode: state.formData.zipCode
			}
		}).then(res => commit('handlerGlobalData', res.data))
			.catch(res => commit('error', res))
	}
}

export default{
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}



// WEBPACK FOOTER //
// ./src/store/modules/ranges.js